type Props = {
  width?: string;
  height?: string;
  fillColor?: string;
  strokeColor?: string;
};

/**
 * Speaker / volume glyph. Used by safe-zone overlays simulating a player
 * mute/unmute control. Distinct from `SpeakersIcon` (people), `SpeakerSelectIcon`
 * (audio routing UI), and `MuteKaraokeIcon` (microphone).
 */
const SpeakerIcon = (props: Props) => {
  const {
    width = '16',
    height = '16',
    fillColor = 'currentColor',
    strokeColor = 'currentColor',
  } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      aria-hidden
    >
      <path d="M8.5 2.5 4.75 5.5H2.25v5h2.5L8.5 13.5v-11Z" fill={fillColor} />
      <path
        d="M11.25 5.25c.85.7 1.4 1.7 1.4 2.75s-.55 2.05-1.4 2.75M12.75 3.5c1.5 1.1 2.5 2.7 2.5 4.5s-1 3.4-2.5 4.5"
        stroke={strokeColor}
        strokeWidth="1.1"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default SpeakerIcon;
